
import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";
import { useSessionContext } from "@supabase/auth-helpers-react";
import { Building, ShoppingBag, Home, User } from "lucide-react";

export function RealEstateNavBar() {
  const navigate = useNavigate();
  const { session } = useSessionContext();

  const navigateToDashboard = () => {
    if (session) {
      navigate("/borrower/dashboard");
    } else {
      navigate("/signin");
    }
  };

  return (
    <header className="border-b bg-white sticky top-0 z-10">
      <nav className="container mx-auto px-4 py-3 flex items-center justify-between">
        <div className="flex items-center space-x-8">
          <div className="flex items-center" onClick={() => navigate("/")} role="button">
            <Building className="h-6 w-6 text-primary mr-2" />
            <span className="font-bold text-xl">Obotan Properties</span>
          </div>
          <div className="hidden md:flex space-x-6">
            <Button variant="link" onClick={() => navigate("/real-estate")}>
              <Home className="h-4 w-4 mr-2" />
              Properties
            </Button>
            <Button variant="link" onClick={() => navigate("/borrower/properties")}>
              <Building className="h-4 w-4 mr-2" />
              My Portfolio
            </Button>
            <Button variant="link" onClick={() => navigate("/shop")}>
              <ShoppingBag className="h-4 w-4 mr-2" />
              Shop
            </Button>
          </div>
        </div>
        <div className="flex items-center space-x-4">
          {session ? (
            <Button size="sm" variant="outline" onClick={navigateToDashboard}>
              <User className="h-4 w-4 mr-2" />
              Dashboard
            </Button>
          ) : (
            <>
              <Button size="sm" variant="ghost" onClick={() => navigate("/signin")}>
                Sign In
              </Button>
              <Button size="sm" onClick={() => navigate("/register")}>
                Create Account
              </Button>
            </>
          )}
        </div>
      </nav>
    </header>
  );
}
